<template>
  <div class="public-layout">
    <!-- Main Content -->
    <main class="public-main-content">
      <slot />
    </main>

    <!-- Floating WhatsApp Button -->
    <div v-if="showWhatsAppButton" class="whatsapp-float">
      <button
        @click="openWhatsApp"
        class="whatsapp-btn"
        title="Chat with us on WhatsApp"
      >
        <i class="fab fa-whatsapp"></i>
      </button>
      <button
        @click="closeWhatsApp"
        class="whatsapp-close-btn"
        title="Close WhatsApp button"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Footer -->
    <footer class="bg-dark text-light py-5">
      <div class="container">
        <div class="row justify-content-between">
          <!-- Address Info -->
          <div class="col-lg-4 col-md-4 mb-4">
            <h6 class="mb-3">Visit us here</h6>
            <div class="address-info">
              <div class="address-item mb-3">
                <i class="fas fa-map-marker-alt me-2 text-primary"></i>
                <span class="address-text">
                  10, Angappa Layout,<br>
                  Edayarpalayam, Coimbatore,<br>
                  Tamil Nadu 641025
                </span>
              </div>
            </div>

            <div class="social-links">
              <a
                href="mailto:gypsysoulsofficial@gmail.com"
                class="social-link me-3"
                title="Email us"
              >
                <i class="fas fa-envelope"></i>
              </a>
              <a
                href="https://www.instagram.com/gypsysouls_travel_company?igsh=MWtuNXU1emlhN3V3ZQ=="
                target="_blank"
                class="social-link me-3"
                title="Follow us on Instagram"
              >
                <i class="fab fa-instagram"></i>
              </a>
              <a
                href="https://wa.me/918870024298"
                target="_blank"
                class="social-link"
                title="Chat with us on WhatsApp"
              >
                <i class="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>

                    <!-- Contact Info -->
          <div class="col-lg-3 col-md-4 mb-4">
            <h6 class="mb-3">Contact Us</h6>
            <div class="contact-info">
              <div class="contact-item mb-2">
                <i class="fas fa-envelope me-2 text-primary"></i>
                <a href="mailto:gypsysoulsofficial@gmail.com" class="footer-link">
                  gypsysoulsofficial@gmail.com
                </a>
              </div>
              <div class="contact-item mb-2">
                <i class="fab fa-instagram me-2 text-primary"></i>
                <a
                  href="https://www.instagram.com/gypsysouls_travel_company?igsh=MWtuNXU1emlhN3V3ZQ=="
                  target="_blank"
                  class="footer-link"
                >
                  GypsySouls Travel Company
                </a>
              </div>
              <div class="contact-item">
                <i class="fab fa-whatsapp me-2 text-primary"></i>
                <a
                  href="https://wa.me/918870024298"
                  target="_blank"
                  class="footer-link"
                >
                  +91 88700 24298
                </a>
              </div>
            </div>
          </div>
          <!-- Quick Links -->
          <div class="col-lg-3 col-md-4 mb-4">
            <h6 class="mb-3">Quick Links</h6>
            <ul class="list-unstyled">
              <li class="mb-2">
                <a href="#" @click.prevent="scrollToTrips" class="footer-link">
                  <i class="fas fa-map-marked-alt me-1"></i>
                  Trips
                </a>
              </li>
              <li class="mb-2">
                <a href="https://share.google/zs9jPwySrMxskqxUg" target="_blank" class="footer-link">
                  <i class="fab fa-google me-1"></i>
                  Google Reviews
                </a>
              </li>
              <li class="mb-2">
                <a href="#" @click.prevent="customizeTrip" class="footer-link">
                  <i class="fas fa-magic me-1"></i>
                  Customize Trip
                </a>
              </li>
              <li class="mb-2">
                <button
                  type="button"
                  class="footer-link footer-legal-btn"
                  @click="openLegalModal('terms')"
                >
                  <i class="fas fa-file-alt me-1"></i>
                  Terms &amp; Conditions
                </button>
              </li>
              <li class="mb-2">
                <button
                  type="button"
                  class="footer-link footer-legal-btn"
                  @click="openLegalModal('privacy')"
                >
                  <i class="fas fa-shield-alt me-1"></i>
                  Privacy Policy
                </button>
              </li>
              <li class="mb-2">
                <button
                  type="button"
                  class="footer-link footer-legal-btn"
                  @click="openLegalModal('disclaimer')"
                >
                  <i class="fas fa-exclamation-circle me-1"></i>
                  Disclaimer
                </button>
              </li>
            </ul>
          </div>

          <!-- Certifications -->
          <div class="col-lg-2 col-md-4 mb-4">
            <h6 class="mb-3">Certifications</h6>
            <div class="certification-item">
              <img
                src="@/assets/msme.png"
                alt="MSME Certification"
                class="certification-img"
                title="Ministry of Micro, Small & Medium Enterprises - Government of India"
              />
            </div>
          </div>

        </div>

        <!-- Copyright -->
        <hr class="my-4" />
        <div class="row align-items-center">
          <div class="col-md-8">
            <p class="mb-1 small legal-business-name">
              M/S Asian Enterprises owned by Jayashankar Vaishnavi
            </p>
            <p class="mb-0 small">
              &copy; {{ new Date().getFullYear() }} Gypsy Souls. All rights
              reserved.
            </p>
            <div class="footer-legal-links">
              <button
                type="button"
                class="footer-link footer-legal-btn"
                @click="openLegalModal('terms')"
              >
                Terms &amp; Conditions
              </button>
              <span class="legal-separator">|</span>
              <button
                type="button"
                class="footer-link footer-legal-btn"
                @click="openLegalModal('privacy')"
              >
                Privacy Policy
              </button>
              <span class="legal-separator">|</span>
              <button
                type="button"
                class="footer-link footer-legal-btn"
                @click="openLegalModal('disclaimer')"
              >
                Disclaimer
              </button>
            </div>
          </div>
          <div class="col-md-4 text-md-end">
            <p class="mb-0 small">
              Made with <i class="fas fa-heart text-danger"></i> for travellers, by travellers
            </p>
          </div>
        </div>
      </div>
    </footer>

    <LegalModal
      :is-visible="showLegalModal"
      :document-type="legalDocumentType"
      @close="closeLegalModal"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import LegalModal from "@/components/LegalModal.vue";

export default {
  name: "PublicLayout",
  components: {
    LegalModal,
  },
  data() {
    return {
      showWhatsAppButton: true,
      showLegalModal: false,
      legalDocumentType: "terms",
    };
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated", "currentUser"]),
  },
  watch: {
    isAuthenticated(newValue) {
      // Show WhatsApp button when user logs in
      if (newValue) {
        this.showWhatsAppButton = true;
      }
    },
  },
  mounted() {
    // WhatsApp button always shows on page load/refresh
    this.showWhatsAppButton = true;
  },
  methods: {
    ...mapActions("auth", ["logout"]),

    async logout() {
      try {
        const result = await Swal.fire({
          title: "Logout Confirmation",
          text: "Are you sure you want to logout?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#2c5aa0",
          cancelButtonColor: "#6c757d",
          confirmButtonText: "Yes, logout",
          cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
          this.$store.dispatch("auth/logout");
          this.$router.push("/login");

          Swal.fire({
            title: "Logged Out",
            text: "You have been successfully logged out.",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });
        }
      } catch (error) {
        console.error("Logout error:", error);
      }
    },

    scrollToReviews() {
      // Scroll to reviews section if on trips page
      if (this.$route.name === "PublicTrips") {
        const reviewsSection = document.querySelector(".reviews-section");
        if (reviewsSection) {
          reviewsSection.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        // Navigate to trips page and scroll to reviews
        this.$router.push("/trips").then(() => {
          setTimeout(() => {
            const reviewsSection = document.querySelector(".reviews-section");
            if (reviewsSection) {
              reviewsSection.scrollIntoView({ behavior: "smooth" });
            }
          }, 100);
        });
      }
    },

    scrollToTrips() {
      // Navigate to trips page and scroll to trips section
      if (this.$route.name === "PublicTrips") {
        // If already on trips page, scroll to trips section
        const tripsSection = document.querySelector(".trips-section");
        if (tripsSection) {
          tripsSection.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        // Navigate to trips page and scroll to trips section
        this.$router.push("/trips").then(() => {
          setTimeout(() => {
            const tripsSection = document.querySelector(".trips-section");
            if (tripsSection) {
              tripsSection.scrollIntoView({ behavior: "smooth" });
            }
          }, 100);
        });
      }
    },

    customizeTrip() {
      // Navigate to trips page and trigger customize trip
      if (this.$route.name === "PublicTrips") {
        // If already on trips page, scroll to customization section
        const customizationSection = document.querySelector(
          ".customization-section"
        );
        if (customizationSection) {
          customizationSection.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        // Navigate to trips page
        this.$router.push("/trips").then(() => {
          setTimeout(() => {
            const customizationSection = document.querySelector(
              ".customization-section"
            );
            if (customizationSection) {
              customizationSection.scrollIntoView({ behavior: "smooth" });
            }
          }, 100);
        });
      }
    },

    openWhatsApp() {
      // Open WhatsApp with the company's number
      const phoneNumber = "918870024298";
      const message =
        "Hi! I'm interested in your travel packages. Can you help me with more information?";
      const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
        message
      )}`;
      window.open(whatsappUrl, "_blank");
    },

    closeWhatsApp() {
      this.showWhatsAppButton = false;
      // Note: Button will reappear on next page refresh/login
    },

    openLegalModal(documentType) {
      this.legalDocumentType = documentType;
      this.showLegalModal = true;
    },

    closeLegalModal() {
      this.showLegalModal = false;
    },
  },
};
</script>

<style scoped>
.public-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Overlay Navbar */
.navbar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1030;
  background: rgba(245, 242, 237, 0.95) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(180, 100, 40, 0.2);
  transition: all 0.3s ease;
}

/* Navbar Phone Contact */
.contact-phone-nav {
  color: #6c757d !important;
  font-weight: 500;
  transition: all 0.3s ease;
}

.contact-phone-nav:hover {
  color: #b46428 !important;
  text-decoration: none;
}

.contact-phone-nav i {
  color: #6c757d;
  transition: color 0.3s ease;
}

.contact-phone-nav:hover i {
  color: #b46428;
}

.navbar-brand {
  font-size: 1.5rem;
  text-decoration: none;
  display: flex;
  align-items: center;
}

.navbar-brand:hover {
  text-decoration: none;
}

.navbar-logo {
  height: 50px;
  width: auto;
  max-width: 200px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.navbar-logo:hover {
  transform: scale(1.05);
}

.nav-link {
  font-weight: 500;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: #b46428 !important;
}

.nav-link.router-link-active {
  color: #b46428 !important;
}

/* Grey icons for about and user */
.nav-link i.fa-info-circle {
  color: #6c757d;
}

.nav-link i.fa-user-circle {
  color: #6c757d;
  transition: color 0.3s ease;
}

/* Grey text for about link */
.nav-link[href="#"] {
  color: #6c757d !important;
}

/* Hover effect only for user icon */
.nav-link:hover i.fa-user-circle {
  color: var(--primary-color);
}

/* Ensure user name follows the icon */
.nav-link.dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.public-main-content {
  margin-left: 0;
  padding: 0;
  min-height: calc(100vh - 200px);
}

.main-content {
  flex: 1;
  padding-top: 1rem;
}

footer {
  margin-top: auto;
  padding-bottom: 5.5rem !important;
}

.footer-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
}

.footer-column {
  flex: 1;
  min-width: 0;
}

.footer-column:first-child {
  margin-left: 0;
}

.footer-column:last-child {
  margin-right: 0;
}

/* Ensure equal spacing between footer sections */
.row.justify-content-between > div {
  margin-bottom: 2rem;
}

.row.justify-content-between > div:last-child {
  margin-bottom: 0;
}

/* Footer Styling */
.footer-logo {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.footer-column h6 {
  color: #fff;
  font-weight: 600;
  margin-bottom: 1rem;
  margin-top: 0;
  line-height: 1.2;
}

/* Ensure all headings are at the same level */
.row.align-items-start h6 {
  margin-top: 0;
  margin-bottom: 1rem;
}

/* Ensure logo and heading alignment */
.footer-logo {
  margin-top: 0;
  margin-bottom: 1rem;
}

.footer-column p {
  color: #adb5bd;
  line-height: 1.6;
}

/* Align all footer columns to the same baseline */
.row.align-items-start > div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

/* Left align the address column */
.col-lg-4 {
  text-align: left;
  align-items: flex-start;
}

/* Left align the side columns */
.col-lg-3 {
  text-align: left;
  align-items: flex-start;
}

/* Ensure proper spacing between sections */
.footer-section {
  padding: 0 1rem;
}

/* Responsive spacing */
@media (min-width: 992px) {
  .row.justify-content-between > div {
    padding: 0 1rem;
  }
}

.footer-logo-img {
  height: 60px;
  width: auto;
  max-width: 250px;
  object-fit: contain;
  filter: brightness(1.2) contrast(1.1);
  transition: transform 0.3s ease;
}

.footer-logo-img:hover {
  transform: scale(1.05);
}

.social-links {
  display: flex;
  align-items: center;
}

.social-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  color: #fff;
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 1.2rem;
}

.social-link:hover {
  background: #b46428;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(180, 100, 40, 0.3);
}

.footer-link {
  color: #adb5bd;
  text-decoration: none;
  transition: color 0.3s ease;
  font-size: 0.9rem;
}

.footer-link:hover {
  color: #b46428;
  text-decoration: none;
}

.contact-item {
  display: flex;
  align-items: center;
}

.address-info {
  margin-bottom: 1rem;
}

.address-item {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

.address-text {
  color: #adb5bd;
  line-height: 1.6;
  font-size: 0.9rem;
}

.legal-business-name {
  color: #e9ecef;
  font-weight: 500;
}

.footer-legal-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem 0.55rem;
  margin-top: 0.65rem;
}

.footer-legal-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font: inherit;
}

.legal-separator {
  color: #6c757d;
  font-size: 0.8rem;
}

.certification-item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.certification-img {
  max-width: 120px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background: white;
  padding: 8px;
}

.certification-img:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

@media (max-width: 768px) {
  .navbar-overlay {
    background: rgba(245, 242, 237, 0.98) !important;
  }

  .navbar-brand {
    font-size: 1.25rem;
  }

  .navbar-logo {
    height: 40px;
    max-width: 150px;
  }

  .main-content {
    padding-top: 0.5rem;
  }

  /* Ensure icons and about text remain grey on mobile */
  .nav-link i.fa-info-circle,
  .nav-link i.fa-user-circle {
    color: #6c757d;
  }

  .nav-link[href="#"] {
    color: #6c757d !important;
  }

  /* Enhanced Footer Mobile Styles */
  footer {
    padding: 2rem 0 5.5rem !important;
  }

  .container {
    padding: 0 1rem;
  }

  .row.justify-content-between {
    flex-direction: column;
    gap: 1.5rem;
  }

  .row.justify-content-between > div {
    margin-bottom: 0;
    width: 100%;
  }

  /* Address Section */
  .col-lg-4 {
    text-align: center !important;
    align-items: center !important;
    margin-bottom: 1.5rem;
  }

  .address-info {
    margin-bottom: 1.5rem;
  }

  .address-item {
    justify-content: center;
    text-align: center;
  }

  .address-text {
    font-size: 0.9rem;
    line-height: 1.5;
  }

  .social-links {
    justify-content: center;
    gap: 1rem;
  }

  .social-link {
    width: 45px;
    height: 45px;
    font-size: 1.3rem;
  }

  /* Contact Section */
  .col-lg-3 {
    text-align: center !important;
    align-items: center !important;
    margin-bottom: 1.5rem;
  }

  .contact-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.8rem;
  }

  .contact-item {
    justify-content: center;
    text-align: center;
  }

  .footer-link {
    font-size: 0.9rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  }

  /* Quick Links Section */
  .col-lg-3:last-of-type {
    text-align: center !important;
    align-items: center !important;
    margin-bottom: 1.5rem;
  }

  .list-unstyled {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.8rem;
  }

  .list-unstyled li {
    margin-bottom: 0;
  }

  /* Certifications Section */
  .col-lg-2 {
    text-align: center !important;
    align-items: center !important;
    margin-bottom: 1rem;
  }

  .certification-img {
    max-width: 120px;
    height: auto;
  }

  /* Copyright Section */
  .row.align-items-center {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .row.align-items-center > [class*="col-md-"] {
    width: 100%;
    text-align: center !important;
  }

  .row.align-items-center > [class*="col-md-"]:last-child {
    margin-top: 0.5rem;
  }

  .footer-legal-links {
    justify-content: center;
  }

  /* Footer Headings */
  h6 {
    font-size: 1.1rem;
    margin-bottom: 1rem;
  }
}

@media (max-width: 576px) {
  .navbar-logo {
    height: 35px;
    max-width: 120px;
  }

  .footer-logo-img {
    height: 50px;
    max-width: 200px;
  }

  /* Mobile phone contact adjustments */
  .contact-phone-nav {
    font-size: 0.9rem;
  }

  /* Enhanced Small Mobile Footer Styles */
  footer {
    padding: 1.5rem 0 !important;
  }

  .container {
    padding: 0 0.8rem;
  }

  .row.justify-content-between {
    gap: 1.2rem;
  }

  /* Address Section - Small Mobile */
  .col-lg-4 {
    margin-bottom: 1.2rem;
  }

  .address-text {
    font-size: 0.85rem;
    line-height: 1.4;
  }

  .social-links {
    gap: 0.8rem;
  }

  .social-link {
    width: 40px;
    height: 40px;
    font-size: 1.1rem;
  }

  /* Contact Section - Small Mobile */
  .col-lg-3 {
    margin-bottom: 1.2rem;
  }

  .contact-info {
    gap: 0.6rem;
  }

  .footer-link {
    font-size: 0.85rem;
  }

  /* Quick Links - Small Mobile */
  .col-lg-3:last-of-type {
    margin-bottom: 1.2rem;
  }

  .list-unstyled {
    gap: 0.6rem;
  }

  /* Certifications - Small Mobile */
  .col-lg-2 {
    margin-bottom: 0.8rem;
  }

  .certification-img {
    max-width: 100px;
  }

  /* Copyright - Small Mobile */
  .row.align-items-center {
    gap: 0.8rem;
  }

  .row.align-items-center > [class*="col-md-"]:last-child {
    margin-top: 0.3rem;
  }

  /* Footer Headings - Small Mobile */
  h6 {
    font-size: 1rem;
    margin-bottom: 0.8rem;
  }

  /* Footer Links - Small Mobile */
  .footer-link {
    font-size: 0.85rem;
    padding: 0.2rem 0;
  }

  /* Contact Items - Small Mobile */
  .contact-item {
    font-size: 0.85rem;
  }

  .contact-item i {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  /* Ultra Small Mobile Footer Styles */
  footer {
    padding: 1.2rem 0 !important;
  }

  .container {
    padding: 0 0.6rem;
  }

  .row.justify-content-between {
    gap: 1rem;
  }

  /* Address Section - Ultra Small Mobile */
  .col-lg-4 {
    margin-bottom: 1rem;
  }

  .address-text {
    font-size: 0.8rem;
    line-height: 1.3;
  }

  .social-links {
    gap: 0.6rem;
  }

  .social-link {
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }

  /* Contact Section - Ultra Small Mobile */
  .col-lg-3 {
    margin-bottom: 1rem;
  }

  .contact-info {
    gap: 0.5rem;
  }

  .footer-link {
    font-size: 0.8rem;
  }

  /* Quick Links - Ultra Small Mobile */
  .col-lg-3:last-of-type {
    margin-bottom: 1rem;
  }

  .list-unstyled {
    gap: 0.5rem;
  }

  /* Certifications - Ultra Small Mobile */
  .col-lg-2 {
    margin-bottom: 0.6rem;
  }

  .certification-img {
    max-width: 80px;
  }

  /* Copyright - Ultra Small Mobile */
  .row.align-items-center {
    gap: 0.6rem;
  }

  .row.align-items-center > [class*="col-md-"]:last-child {
    margin-top: 0.2rem;
  }

  /* Footer Headings - Ultra Small Mobile */
  h6 {
    font-size: 0.95rem;
    margin-bottom: 0.6rem;
  }

  /* Footer Links - Ultra Small Mobile */
  .footer-link {
    font-size: 0.8rem;
    padding: 0.1rem 0;
  }

  /* Contact Items - Ultra Small Mobile */
  .contact-item {
    font-size: 0.8rem;
  }

  .contact-item i {
    font-size: 0.85rem;
  }

  /* Address Items - Ultra Small Mobile */
  .address-item i {
    font-size: 0.9rem;
  }
}

/* WhatsApp Floating Button */
.whatsapp-float {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.whatsapp-btn {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
  border: none;
  border-radius: 50%;
  color: white;
  font-size: 28px;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.whatsapp-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  transition: left 0.6s ease;
}

.whatsapp-btn:hover {
  transform: translateY(-3px) scale(1.1);
  box-shadow: 0 8px 30px rgba(37, 211, 102, 0.6);
}

.whatsapp-btn:hover::before {
  left: 100%;
}

.whatsapp-btn:active {
  transform: translateY(-1px) scale(1.05);
}

.whatsapp-close-btn {
  width: 30px;
  height: 30px;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 50%;
  color: white;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
}

.whatsapp-close-btn:hover {
  background: rgba(0, 0, 0, 0.9);
  transform: scale(1.1);
}

/* Animation for WhatsApp button appearance */
@keyframes whatsappPulse {
  0% {
    box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
  }
  50% {
    box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4),
      0 0 0 10px rgba(37, 211, 102, 0.1);
  }
  100% {
    box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
  }
}

.whatsapp-btn {
  animation: whatsappPulse 2s infinite;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .whatsapp-float {
    right: 15px;
    bottom: 15px;
  }

  .whatsapp-btn {
    width: 50px;
    height: 50px;
    font-size: 24px;
  }

  .whatsapp-close-btn {
    width: 25px;
    height: 25px;
    font-size: 10px;
  }
}
</style>
